<template>
  <div class="dailyMeeting  w98" style="height: calc(100vh - 50px); overflow-y: auto; overflow-x: hidden;" >
    <div class="crumbs" >
      <span><router-link to="/EntryPage">首页</router-link>  > </span>
      <span>每日读片</span>
    </div>
          <!--<el-button   size="small" class="new-events" @click="newClick">新建事件</el-button>-->
          <div size="small" v-show="isAllowAdd"  class="new-events" @click="newClick">新建事件</div>
          <div size="small" v-show="isAllowDel" class="new-events delBut" @click="delClick">批量删除</div>
      <full-calendar
        :events="fcEvents"
        first-day='1'
        @eventClick="eventClick"
        @moreClick="moreClick"
        @changeMonth="changeMonth"
        >
          <template slot="fc-event-card" scope="p">
              <p :title="p.event.title">{{ p.event.title }}</p>
          </template>
      </full-calendar>
    <pop v-if="delPop" :show="delPop" @closePop="closePop" :title='"批量删除"' :width="'660px'">
      <del-daily @delSuccess="delSuccess" @cancelDelDailyMeeting="cancelDelDailyMeeting" ></del-daily>
     </pop>
    <!-- 事件详情 -->
      <pop v-if="pop" :show="pop" @closePop="closePop" :title='popTitile' :width="'980px'">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="事件名称" prop="name">
                  <el-input v-model="form.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="开始日期" prop=" ">
                <el-col :span="20" style="line-height: 26px;">
                  {{ startTime }}
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="事件时间" prop="eventTimestart">
              <el-row type="flex" :gutter="10" justify="space-between">
                <el-col  :span="12">
                  <el-time-select
                    placeholder="起始时间"
                    class="select-time"
                    @change="timeStartchange"
                    v-model="form.eventTimestart"
                    :picker-options="{
                      start: '07:00',
                      step: '00:30',
                      end: '24:00'
                    }">
                  </el-time-select>
                </el-col>
                <el-col  :span="12">
                  <el-time-select
                    placeholder="结束时间"
                    class="select-time"
                    v-model="form.eventTimeend"
                    :picker-options="{
                      start: '07:00',
                      step: '00:30',
                      end: '24:00',
                      minTime: form.eventTimestart
                    }">
                  </el-time-select>
                </el-col>
              </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="事件类型" prop="secType" >
                <el-select v-model="form.secType" disabled >
                  <el-option label="晨读会" value="1"></el-option>
                  <el-option label="业务学习" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 120px;">
            <el-col :span="24">
              <el-form-item label="备注">
                  <el-input type="textarea" placeholder="请输入备注" style="margin-top: 7px;" :rows="4" v-model="form.remarks" >
                  </el-input>
              </el-form-item>
            </el-col>
          </el-row>
           <span style="margin-left:100px;">已输入{{form.remarks.length - textLength}}个</span>
          <el-row type="flex" justify="center">
                <el-button type="primary" class="save-btn" v-show="saveBool" @click="closesavePop">保存资料</el-button>
                <el-button type="primary" class="del-btn" v-show="delBool" @click="delMeeting">删除事件</el-button>
                <el-button type="primary" class="enter-btn" v-show="enterBool"  @click="enterMeeting()">进入会议 >></el-button>
          </el-row>
        </el-form>
      </pop>

    <!-- 新建事件 -->
      <pop v-if="pop2" :show="pop2" @closePop="closePop" :title="'新建事件'" :width="'800px'">
        <el-form ref="form1" :rules="rules2" :model="form1" label-width="80px">
          <el-row>
            <el-col :span="24">
              <el-form-item label="事件名称" prop="confName">
                  <el-input v-model="form1.confName" :maxlength="confNameLength"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">
              <el-form-item label="重复周期" prop="repeatFlag">
                <el-select v-model="form1.repeatFlag">
                  <el-option label="无" value="0"></el-option>
                  <el-option label="按周" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="19">
              <el-checkbox-group v-model="weekList"  class="weeklist" v-show="form1.repeatFlag == '1' ? true:false">
                  <el-checkbox v-for="weekday in weeks" :label="weekday">{{weekday}}</el-checkbox>
              </el-checkbox-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="事件日期" prop="startDate">
              <el-row>
                <el-col  :span="24">
                  <el-date-picker
                    v-model="form1.startDate"
                    class="select-time"
                    style="margin-top: 9px; width: 100%;"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions1">
                  </el-date-picker>
                  <!--<el-date-picker-->
                    <!--placeholder="起始时间"-->
                    <!--class="select-time"-->
                    <!--v-model="form1.startDate"-->
                    <!--:picker-options="pickerOptions1">-->
                  <!--</el-date-picker>-->
                <!--</el-col>-->
                <!--<span>~</span>-->
                <!--<el-col  :span="12">-->
                  <!--<el-date-picker-->
                    <!--placeholder="结束时间"-->
                    <!--class="select-time"-->
                    <!--v-model="form1.endDate"-->
                    <!--:picker-options="pickerOptions1">-->
                  <!--</el-date-picker>-->
                </el-col>
              </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="事件时间" prop="startHm">
              <el-row type="flex" :gutter="10" justify="space-between">
                <el-col  :span="12">
                  <el-time-select
                    placeholder="起始时间"
                    class="select-time"
                    @change="timeStartchange"
                    v-model="form1.startHm"
                    :picker-options="{
                      start: '07:00',
                      step: '00:30',
                      end: '24:00'
                    }">
                  </el-time-select>
                </el-col>
                <span>~</span>
                <el-col  :span="12">
                  <el-time-select
                    placeholder="结束时间"
                    class="select-time"
                    v-model="form1.endHm"
                    :picker-options="{
                      start: '07:00',
                      step: '00:30',
                      end: '24:00',
                      minTime: form1.startHm
                    }">
                  </el-time-select>
                </el-col>
              </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="事件类型" prop="confType" style="float: right;">
                <el-select v-model="form1.confType">
                  <el-option label="晨读会" value="1"></el-option>
                  <el-option label="业务学习" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="height: 120px;">
            <el-col :span="24">
              <!--<el-form-item label="备注">-->
                  <!--<el-input type="textarea" placeholder="请输入备注" style="margin-top: 7px;" :rows="4" v-model="form1.remark" :maxlength="200" ></el-input>-->
              <!--</el-form-item>-->
              <el-form-item label="备注">
                <el-input type="textarea" maxlength='200' placeholder="请输入备注" style="margin-top: 7px;" :rows="4" v-model="form1.remarks"
                          @input="changeInput"
                >
                  <template>
                    <span></span>
                  </template>
                </el-input>
                <span>已输入{{form1.remarks.length - textLength}}个</span>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="btn-box" style="margin-top: 15px;">
            <el-button type="primary"
                       v-loading.fullscreen.lock="fullscreenLoading"
                       @click="saveFun('form1')"
                       class="save">
                     确定
            </el-button>
            <el-button @click="cancenFun()" class="cancel">取消</el-button>
          </div>
        </el-form>
      </pop>
  </div>
</template>

<script type="text/ecmascript-6">
  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'
  import pop from '@/components/common/pops/pop'
  import btns from '@/components/common/button/buttons'
  import rightPops from '@/components/common/right/rightPops'
  import fullCalendar from '@/components/common/fullCalendar/fullCalendar'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import moment from 'moment'
  import delDaily from '@/components/moudle/dailyMeeting/delDailyMeeting'

  const weeks = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
  export default {
    data() {
      return {
            fcEvents: [
                // {
                //   title: '晨读会 07:00 - 08:00',
                //   start: '2018-04-26',
                //   end: '2018-04-26',
                //   remarks:'啦啦啦啦啦啦啦'
                // }
            ],
            textLengths: '',
            textLength: '',
            pop: false,
            pop2:false,
            delPop:false,//批量删除弹框控制
            saveBool: true,
            weekList:[],
            weeks:weeks,
            weekshow:false,
            enterBool: true,
            popTitile:'事件详情',
            startTime: ' ',
            form: {
              name: '',
              secType:'',
              eventDatestart:'',
              eventDateend:'',
              eventTimestart: '',
              eventTimeend: '',
              remarks: '',
              status: '',
              id: ''
            },
            form1: {
              confName: '',
              confType:'1',
              startDate:'',
              startHm: '',
              endHm: '',
              repeatFlag: '1',
              remarks: '',
            },
            remarkLength: '0',
            confNameLength: 24,
            monthTimeVal: '',
            rules: {
              name: [
                { required: true, message: '请输入会议名称', trigger: 'blur' }
              ],
              eventTimestart: [
                { required: true, message: '请选择时间', trigger: 'change' }
              ],
              startDate: [
                { required: true, message: '请选择时间', trigger: 'change' }
              ],
              startHm: [
                { required: true, message: '请选择时间', trigger: 'change' }
              ],
              secType: [
                { required: true, message: '请选择时间类型', trigger: 'change' }
              ],
              confType: [
                { required: true, message: '请选择事件类型', trigger: 'change' }
              ],
              confName: [
                { required: true, message: '请输入会议名称', trigger: 'blur' }
              ]
            },
            rules2: {
              confName: [
                { required: true, message: '请输入会议名称', trigger: 'blur' }
              ],
              repeatFlag: [
                { required: true, message: '请选择周期', trigger: 'change' }
              ],
              startDate: [
                { required: true, message: '请选择时间', trigger: 'change' }
              ],
              startHm: [
                { required: true, message: '请选择时间', trigger: 'change' }
              ],
              confType: [
                { required: true, message: '请选择事件类型', trigger: 'change' }
              ],
            },
            pickerOptions1: {
              disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7;;
              }
            },
            fullscreenLoading: false,
            delBool:true,//单个事件删除按钮 是否显示
            isAllowAdd:false,//用户是否允许新增
            isAllowDel:false,//用户是否允许删除
            dailyMeetingData:{},
      }
    },
    components : {
      'full-calendar': fullCalendar,
      pop,
      btns,
      rightPops,
      delDaily
    },
    created() {
      this.getUserJurisdiction();
    },
    methods: {
      //获取用户权限 判断用户是否有删除 新增权限
      getUserJurisdiction(){
        this.rootList=[];
        http.post('/getUserJurisdiction.json', {}).then(res => {
          if (res.data.code === _.ERR_OK) {
            const data = res.data.model;
            const {jurisdictionArray} = data;
            let rootList = [];
            if(jurisdictionArray){
              jurisdictionArray.forEach(item=>{
                rootList.push(item.jurisdictionId)
              })
              // 新增事件权限 2006,
              // 删除事件权限 2008
              if(rootList.indexOf(2006) !== -1){
                this.isAllowAdd = true;
              }
              if(rootList.indexOf(2008) !== -1){
                this.isAllowDel = true;
              }
            }

          }else{
            message(res.data.msg, false);
          }
        }).catch((e) => {
           message(`请求错误,${e}`, false);
        })
      },
      cancelDelDailyMeeting(){
        this.delPop=false;
      },
      delSuccess(){
        this.delPop=false;
        this.getDailyData();
      },
      getDailyData(){//列表获取
        http.post('/conference/getDailyConferenceList.json', {"monthTime": this.monthTimeVal }).then(res => {
          this.fcEvents = []
          this.getConferenceList(res)
        }).catch((e) => {
           message(`请求错误,${e}`, false);
        })
      },
      delMeeting(){//删除事件
        this.$confirm('是否确定要删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let parmars = {
            meetId:this.form.id,
          };
          http.post("/conference/deleteMeetSingle.json", parmars).then(res => {
            if (res.data.code === _.ERR_OK) {
              message(res.data.msg , true);
              this.pop = false;
              this.getDailyData();
            }else{
              message(res.data.msg, false);
            }
          }).catch(e=>{
            message(`请求错误,${e}`, false);
          });
        }).catch(e=>{

        })
      },
      closePop(payload) {
        this.pop = false
        this.pop2 = false
        this.delPop = false
        // console.log('关闭')
        // console.log(this.form.name)
        // console.log(this.form.eventTimestart)
      },
      closesavePop() {
        this.pop = false
        // console.log('关闭+修改')
        // if(this.form.status == 1 || this.form.status == 2) {
        //   message('会议已结束/已过期，不允许修改资料', false)
        // }
        // else {
          let startDateStrVal = ''
          let endDateStrVal = ''
          startDateStrVal = this.startTime+' '+this.form.eventTimestart+':00'
          endDateStrVal = this.startTime+' '+this.form.eventTimeend+':00'
          // console.log(startDateStrVal, endDateStrVal)
          // console.log('id========')
          // console.log(this.form.id)
          let updateJson = {
            id: this.form.id,
            confName: this.form.name,
            startDateStr: startDateStrVal,
            endDateStr: endDateStrVal,
            remark: this.form.remarks
          }
          http.post('/conference/updateDailyConferenceById.json', updateJson).then(res => {
            // console.log('会议修改')
             // console.log(res,'jjjjj')
            if (res.data.code === _.ERR_OK) {
              message('会议已修改', true)
              this.getDailyData();
            }else{
              this.$alert(res.data.msg)
            }
          }).catch(() => {

          })


        // }

      },
      moreClick(){

      },
      changeInput(){
        let text=  this.form.remarks.length
        let len
        let max=200
        if(text<=max ){
          var str = max-text
          this.textLengths=str.toString();

          len=0;
        }else{
          this.textLength = 200 - text;
        }
      },
      delClick(){
        this.delPop = true;
      },
      newClick() {
        this.pop2 = true
        // console.log(this.form1)
      },
      eventClick(event, jsEvent, pos) {

        this.dailyMeetingData = event

        this.pop = true
        // console.log(this)
        // console.log(this.$data)
        if(event.status == '1' || event.status == '2') {
          this.saveBool = false
        } else {
          this.saveBool = true
        }
        //先判断是否有删除权限 再判断是否需要显示删除按钮
        if(this.isAllowDel){
          //会议状态（0-未开始，1-结束，2-过期 3-进行中）
          if(event.status === 0){//可删除【未开始】状态的当前事件。【进行中】【已结束】状态事件删除事件按钮不显示。
            this.delBool = true;
          }else{
            this.delBool = false;
          }
        }else{
          this.delBool = false;
        }

        // let currentTime = ''
        // let myDate = new Date()
        //   //获取当前年
        // let year=myDate.getFullYear()
        //   //获取当前月
        // let month=myDate.getMonth()+1
        //   //获取当前日
        // let date=myDate.getDate()
        // if(month < '10') {
        //   month = '0'+month
        // }
        // if(date < '10') {
        //   date = '0'+date
        // }
        // currentTime = year+'-'+month+'-'+date
        // console.log('当前时间')
        // console.log(currentTime)
        // if(currentTime == event.start || event.status == '1' || event.status == '2' || event.status == '3') {
        if(event.status == '3' || event.status == '1' || event.status == '2'  ) {
          this.enterBool = true
        } else {
          this.enterBool = false
          }
        //  console.log(event,'sss')
       // console.log(event.remark,'s')
       // console.log( this.form.eventTimeend,'ss')
        this.form.name = event.confName
        this.startTime = event.start
        this.form.eventTimestart = event.hmstart
        this.form.eventTimeend = event.hmend
        this.form.remarks = event.remark

        if(event.confType == 1) {
          this.form.secType = '晨读会'
        } else if(event.confType == 2) {
          this.form.secType = '业务学习'
        }
        this.form.status = event.status
        this.form.id = event.id
      },
      // 'dayClick' (day, jsEvent) {
      //   console.log('dayClick', day, jsEvent)
      // },
      // 'moreClick' (day, events, jsEvent) {
      //   console.log('moreCLick', day, events, jsEvent)
      // },
      changeMonth(start, end, current) {
        let getMonths = new Date(current.format()).getMonth() + 1
        if(getMonths < 10) {
          getMonths = '0'+getMonths
        }
        let monthTime = new Date(current.format()).getFullYear()+'-'+getMonths
        this.monthTimeVal = monthTime
        this.getDailyData();
      },
      getConferenceList(res) {

         if (res.data.code === _.ERR_OK) {
          for(let item of res.data.model) {
            var endVal = item.endDateStr.slice(0,item.endDateStr.indexOf(' '));
            var startVal = item.startDateStr.slice(0,item.startDateStr.indexOf(' '));
            var remark = item.remark?item.remark:"";
            var hmstartVal =item.startDateStr.slice(item.startDateStr.indexOf(' ')+1,item.startDateStr.length);
            var hmendVal = item.endDateStr.slice(item.endDateStr.indexOf(' ')+1,item.endDateStr.length);
            var confTypeVal = ''
            if(item.confType == 1) {
              confTypeVal = '晨读会'
            } else if(item.confType == 2) {
              confTypeVal = '业务学习'
            }
            var titleVal = item.confName+' '+hmstartVal+'-'+hmendVal

            this.fcEvents.push({

              title: titleVal,
              start: startVal,
              end: endVal,
              confName: item.confName,//会议名称
              id: item.id,
              confType: item.confType,
              status: item.status,
              hmstart: hmstartVal,
              hmend: hmendVal,
              remark
            })
          }
         }
        let userAgent = window.navigator.userAgent
        if (userAgent.indexOf('NET') != -1 && userAgent.indexOf("rv") != -1) {
          return false
        } else {
          this.fcEvents.reverse()
        }
      },
      enterMeeting() {
          const {hmend,hmstart,start,end} = this.dailyMeetingData;
          const startData = start +" "+hmstart
          const endData = end +" "+hmend
          const startTime = new Date(startData).getTime();
          const endTime = new Date(endData).getTime();
          const nowTime = new Date().getTime();
          //进行中 已结束 过期均可进入会议
          if(startTime > nowTime){
             //未开始
            this.$message.error("会议未开始");
          }else{
            this.pop = !pop
            this.popShow = true
            this.$router.push({name: 'DailyDetail',params:{}})
            saveLocalStorage(this.form.id, 'formid')
          }
          // if(startTime < nowTime && nowTime < endTime){
          //   this.pop = !pop
          //   this.popShow = true
          //   this.$router.push({name: 'DailyDetail',params:{}})
          //   saveLocalStorage(this.form.id, 'formid')
          // }else if(startTime > nowTime){
          //   //未开始
          //   this.$message.error("会议未开始");
          // }else if(endTime < nowTime){
          //   //已结束
          //   this.$message.error("会议已结束");
          // }


      },
      timeStartchange() {
        this.form.eventTimeend = ''
      },
      saveFun(form) {

        this.$refs[form].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true;
            let startTime = new Date(this.form1.startDate[0])
            let endTime = new Date(this.form1.startDate[1])
            let startDate = ""
            let endDate = ""
            let startGetDate=startTime.getDate()
            let endTimeDate=endTime.getDate()
            let startgetMonth=startTime.getMonth() + 1
            let endgetMonth=endTime.getMonth() + 1
            if(startGetDate<10){
              startGetDate='0'+startGetDate
            }
            if(endTimeDate<10){
              endTimeDate='0'+endTimeDate
            }
            if(startgetMonth<10){
              startgetMonth='0'+startgetMonth
            }
            if(endgetMonth<10){
              endgetMonth='0'+endgetMonth
            }
            startDate = startTime.getFullYear() + '-' + startgetMonth + '-' + startGetDate
            endDate = endTime.getFullYear() + '-' + endgetMonth + '-' + endTimeDate
            let chooseTimeStr = ''
            for(let item of this.weekList) {
              if(item == '周一') {
                chooseTimeStr = chooseTimeStr + '1' + ','
              } else if(item == '周二') {
                chooseTimeStr = chooseTimeStr + '2' + ','
              } else if(item == '周三') {
                chooseTimeStr = chooseTimeStr + '3' + ','
              } else if(item == '周四') {
                chooseTimeStr = chooseTimeStr + '4' + ','
              } else if(item == '周五') {
                chooseTimeStr = chooseTimeStr + '5' + ','
              } else if(item == '周六') {
                chooseTimeStr = chooseTimeStr + '6' + ','
              } else if(item == '周日') {
                chooseTimeStr = chooseTimeStr + '7' + ','
              }
            }
            // chooseTimeStr = chooseTimeStr.slice(0,chooseTimeStr.length-1)
            let startHm = this.form1.startHm + ':00'
            let endHm = this.form1.endHm + ':00'
            let param = {
              confName: this.form1.confName,
              confType: this.form1.confType,
              startDate: startDate,
              endDate: endDate,
              repeatFlag: this.form1.repeatFlag,
              chooseTimeStr: chooseTimeStr,
              startHm: startHm,
              endHm: endHm,
              remark: this.form1.remarks
            }
            http.post('/conference/conferenceSchedule.json',param).then(res => {
               this.fullscreenLoading = false;
              if (res.data.code === _.ERR_OK) {
                message(res.data.msg,true)
                this.pop2 = false
                // 清空
                this.form1.confName = ''
                this.form1.confType = '1'
                this.form1.startDate = ''
                this.form1.endDate = ''
                this.form1.startHm = ''
                this.form1.endHm = ''
                this.form1.repeatFlag = '1'
                this.form1.remarks = ''

                this.weekList = []
                this.getDailyData();

              } else {
                message(res.data.msg,false)
              }
            }).catch(() => {

            })
          } else {
            return false
          }
        })
      },
      cancenFun() {
        this.pop2 = false
      }
    },
    watch: {
      // remarkLength: function (val, oldVal) {
      //   console.log('new: %s, old: %s', val, oldVal)
      // },
      // remark: function(val, oldVal) {
      //   console.log('new: %s, old: %s', val, oldVal)
      // },
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .w98
    position: relative
    width: 98%
    margin: auto

  .full-calendar-header  .header-center .title
    color: #000

  .week
    color: #000

  .fc-grey{
    background-color: rgb(239,239,239);
    color: $color-text-mid-grey;}

  .comp-full-calendar
    min-width: 960px
    width 97%

  .select-time input
    width:100%

  .save-btn
    width 118px
    background: $color-yellow
    border-color: $color-yellow
    &:hover
      background: #fff

  del-btn
    width 118px
    background: $color-green
    border-color: $color-green
    &:hover
      background: #fff
//新建事件
  .new-events
    position absolute
    right 20px
    top 50px
    border 1px solid
    background: $color-background-hover
    color: $button-text-color
    width: 80px;
    height: 30px;
    text-align : center;
    line-height: 30px;
    cursor: pointer;
    border-radius: 5px
  .delBut
    right 120px;
   // &.el-button:hover
   //   border-color $color-green
  //  &.el-button--primary:focus
  //    background $color-green

  .weeklist
    margin-left:25px

  .btn-box
    text-align: center
    .save-hair, .saving, .save, .cancel
      width: 180px
      height: 35px
      border: none
      color: $button-text-color
    .save
      background: $color-background-hover
      margin-right: 80px
    .commonBtn
      width: 90px
    .cancel
      background: $button-del
</style>



// WEBPACK FOOTER //
// dailyMeeting.vue?6b51d4b3